module.exports = __webpack_public_path__ + "img/09.fd694292.jpg";